import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./HomeStyles";

const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Data from Home page
  const { name, eventText, customEventText, photo } = location.state || {};

  // Customer Details
  const [customerName, setCustomerName] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);

  // Redirect back if no design data
  if (!location.state) {
    navigate("/");
  }

  const handleConfirmOrder = async () => {
    if (!customerName || !mobile || !address) {
      alert("Please fill all details");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("wrapper_name", name);
      formData.append("event_text", eventText || "");
      formData.append("custom_event_text", customEventText || "");
      formData.append("customer_name", customerName);
      formData.append("mobile", mobile);
      formData.append("address", address);
      formData.append("quantity", quantity);
      formData.append("payment_status", "pending");

      // Convert base64 image to blob
      if (photo) {
        const response = await fetch(photo);
        const blob = await response.blob();
        formData.append("photo", blob, "photo.png");
      }

      const res = await axios.post(
        "http://localhost:8000/api/orders/",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const orderId = res.data.id;

      // Redirect to payment page
      navigate(`/payment/${orderId}`);
    } catch (error) {
      console.error(error);
      alert("Order submission failed.");
    }

    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Confirm Your Order</h1>

      {/* Wrapper Preview */}
      <div style={{ marginBottom: "40px" }}>
        <div style={styles.wrapper}>
          <div style={styles.wrapperBorder} />

          <div style={styles.topText}>
            {(eventText || customEventText || "SPECIAL EDITION").toUpperCase()}
          </div>

          {photo && (
            <div style={{ marginTop: "30px" }}>
              <img
                src={photo}
                alt="Preview"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </div>
          )}

          <div style={styles.nameSection}>
            <div style={styles.exclusivelyFor}>EXCLUSIVELY FOR</div>
            <div style={styles.recipientName}>
              {name?.toUpperCase()}
            </div>
          </div>
        </div>
      </div>

      {/* Customer Details Form */}
      <div style={styles.uiPanel}>
        <input
          type="text"
          placeholder="Your Full Name"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          style={styles.inputText}
        />

        <input
          type="text"
          placeholder="Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          style={styles.inputText}
        />

        <textarea
          placeholder="Delivery Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          style={{
            ...styles.inputText,
            width: "100%",
            height: "90px",
          }}
        />

        <input
          type="number"
          min="1"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          style={styles.inputText}
        />

        <button
          onClick={handleConfirmOrder}
          style={styles.buttonOrder}
        >
          {loading ? "Processing..." : "Confirm Order"}
        </button>
      </div>
    </div>
  );
};

export default Checkout;
